import { useOfficialExam } from '@/modules/official-exam/presentation/hooks/use-official-exam';
import {
  SendGabaritoAction,
  useGabaritoSubmission,
} from '@/modules/gabarito/presentation/components/SendGabaritoAction';
import { useMyGabarito } from '../hooks/use-my-gabarito';
import { EmptyState, TabSkeleton } from './EmptyState';
import { ReviewQuestionCard } from './ReviewQuestionCard';

/**
 * A aba Prova Oficial: as questões da prova, comentadas, com a resposta certa
 * e — para quem enviou o gabarito — a que a pessoa marcou. É a aba "Questões"
 * do `enamed-feedback-lp`.
 *
 * Abre mesmo sem gabarito enviado: a prova comentada vale como estudo, e quem
 * ainda não enviou ganha o convite no topo.
 */
export function ProvaOficialTab() {
  const officialExam = useOfficialExam();
  const myGabarito = useMyGabarito();
  const submission = useGabaritoSubmission();

  if (officialExam.isPending) {
    return <TabSkeleton label="Carregando a prova oficial" />;
  }

  if (officialExam.isError || !officialExam.data) {
    return (
      <EmptyState
        title="Prova oficial"
        note="A prova comentada aparece aqui assim que for publicada pelo nosso time."
      />
    );
  }

  return (
    <div className="stack-md">
      {/* Só com o envio aberto: convidar a enviar o que não dá para enviar
          seria um beco. */}
      {submission === 'open' &&
        !myGabarito.isPending &&
        !myGabarito.answers && (
          <p className="notice">
            Envie seu gabarito para ver, em cada questão, o que você marcou.{' '}
            <SendGabaritoAction variant="link" local="painel" />
          </p>
        )}

      {officialExam.data.map((question) => (
        <ReviewQuestionCard
          key={question.questionId}
          question={question}
          picked={myGabarito.answers?.[question.number]}
        />
      ))}
    </div>
  );
}
